import { AxDropdown, AxFormValidation } from "@axess/limestone";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { AccountStorageService, IAccountStorageObject } from "../../Service/Account/AccountStorageService";
import { IAxBirthDateInitData } from "../Global/AxBirthDateInputTriple";

@ModuleName("Registration")
export class Registration implements AxInit {
    constructor(
        private _storage = new AccountStorageService(),
        private _requestHelper = new RequestHelper()
    ) { }

    private _CountryDropDown: AxDropdown = new AxDropdown();
    private _StateDropDown: AxDropdown = new AxDropdown();
    private _CountryDropDownShipping: AxDropdown = new AxDropdown();
    private _StateDropDownShipping: AxDropdown = new AxDropdown();
    private _CommunicationLanguage: AxDropdown = new AxDropdown();
    private _RentalWeightDropDown: AxDropdown = new AxDropdown();
    private _RentalHeightDropDown: AxDropdown = new AxDropdown();
    private _RentalShowSizeDropDown: AxDropdown = new AxDropdown();
    private _RentalSkiLevelDropDown: AxDropdown = new AxDropdown();
    private _GenderDropdown: AxDropdown = new AxDropdown();
    private initData!: IRegistrationData;

    private countryList: CountryList[] = [];
    private parentSelector;

    private subDivisionSearchTimeout: NodeJS.Timeout;
    private _I18nHelper = new I18nHelper;

    AxInit(init: IRegistrationData): void {
        this.initData = init;
        this._storage.init(init.formData);
        this.parentSelector = init.parentId;

        AxLoad.LoadModule('AxBirthDateInputTriple', init);
        AxLoad.LoadModule('RegisterForm', init);

        const currentUrl = new URL(window.location.href);
        if (!this._storage.isAccountPage(currentUrl)) {
            history.replaceState({}, $(document).find("title").text(), init.loginUrl);
        }
        const currentStorage = this._storage.getStorage();
        if (currentStorage?.referrer != null && currentStorage.referrer.toLowerCase().indexOf('shoppingcart') !== -1) {
            $('[data-login="guest"]').removeClass('d-none');
            $('[data-altcha-login]').addClass('login-guest');
        }

        this._GenderDropdown.init(`${init.parentId} .accountsettings__gender`);

        this._CountryDropDown.init(`${init.parentId} .register__countryCode-AddressViewModel`, {
            searchBar: true,
            multiSelect: false,
            onSelect: (_, y) => {
                this.subDivisionSearchTimeout = setTimeout(() => this.searchSubDivision(), 200);
                // Careful with the dot in the name & jQuery
                $('[id="AddressViewModel.CountryCode"]').val(y)
                if (this.initData.addressType === AddressType.USA) {
                    $('[id="AddressViewModel.CountryCode"]').trigger('input.shippingSync');
                }
            }
        });

        this._StateDropDown.init('.register__state-AddressViewModel', {
            searchBar: true,
            multiSelect: false,
            onSelect: (_, y) => {
                // Careful with the dot in the name & jQuery
                $('[id="AddressViewModel.State"]').val(y);
                if (this.initData.addressType === AddressType.USA) {
                    $('[id="AddressViewModel.State"]').trigger('input.shippingSync');
                }
            }
        });

        if (this.initData.addressType === AddressType.USA) {
            this._CountryDropDownShipping.init(`${init.parentId} .register__countryCode-DeliveryAddressViewModel`, {
                searchBar: true,
                multiSelect: false,
                onSelect: (_, y) => {
                    this.subDivisionSearchTimeout = setTimeout(() => this.searchSubDivision(), 200);
                    // Careful with the dot in the name & jQuery
                    $('[id="DeliveryAddressViewModel.CountryCode"]').val(y)
                }
            });

            this._StateDropDownShipping.init('.register__state-DeliveryAddressViewModel', {
                searchBar: true,
                multiSelect: false,
                onSelect: (_, y) => {
                    // Careful with the dot in the name & jQuery
                    $('[id="DeliveryAddressViewModel.State"]').val(y);
                }
            });
        }

        this._CommunicationLanguage.init('.register__language', {
            searchBar: false,
            multiSelect: false,
            onSelect: (_, y) => {
                $('#Language').val(y);
            }
        });

        $(`.accountsettings__postalCode`).on("keyup", () => {
            if (typeof this.subDivisionSearchTimeout != 'undefined') {
                clearTimeout(this.subDivisionSearchTimeout);
            }

            this.subDivisionSearchTimeout = setTimeout(() => this.searchSubDivision(), 200);
        });

        $(init.rental_parentId).on("change", "input[type=radio]", (e) => {
            const rentalViewModel = {
                Height: $("#RentalHeight").val(),
                Weight: $("#RentalWeight").val(),
                ShoeSize: $("#RentalShoeSize").val(),
                SkiLevel: $("#RentalSkiLevel").val()
            };

            AxessViewer.loadPartialView('/Account/GetAccRentalInfo', {
                rentalViewModel,
                unit: e.currentTarget.value,
            }, (res: { view: string }) => {
                $('#registration__rentalContainer').html(res.view);
                this.initRentDropdowns(this);
            }, null);
        });
        this.initRentDropdowns(this);

        //GuestForm
        new AxFormValidation({
            selector: '#guestForm',
            rules: {
                guestEmail: {
                    required: true,
                    email: true,
                    regex: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i,
                },
                guestConfirmEmail: {
                    required: true,
                    equalTo: "#guestEmail"
                },
            }
        }).init();

        $('[data-checkout="guest"]').on('click', () => {
            this.guestCheckout();
        });

        if (this.initData.addressType === AddressType.USA) {
            const $sameAddressCheck = $('input[name="same-address"]');
            const $shippingFieldset = $sameAddressCheck.closest('fieldset')
            const $billingFieldset = $shippingFieldset.prev('fieldset');
            const $inputGroup = $shippingFieldset.find('input').last().closest('[data-name-prefix]');
            const shippingieldsetPrefix = $inputGroup.attr('data-name-prefix');
            const syncInput = (el: HTMLInputElement) => {
                const name = el.name.split('.').pop();
                if (el.value) {
                    if (name === 'CountryCode') {
                        this._CountryDropDownShipping.setValue(el.value)
                    }
                    if (name === 'State') {
                        this._StateDropDownShipping.setValue(el.value)
                    }
                }
                $shippingFieldset.find(`[name="${shippingieldsetPrefix}.${name}"]`).val(el.value);
            }

            $sameAddressCheck.on('change', () => {
                const isChecked = $sameAddressCheck.is(':checked');
                $shippingFieldset.find('[data-same-address]')[isChecked ? 'addClass' : 'removeClass']('d-none');
                if (isChecked) {
                    $billingFieldset.find('input').each((_, el) => syncInput(el));
                    $billingFieldset.on('keyup.shippingSync input.shippingSync', 'input', (e) => syncInput(e.currentTarget));
                } else {
                    $billingFieldset.off('keyup.shippingSync input.shippingSync', 'input');
                }
            });
        }
    }

    guestCheckout() {
        const currentStorage = this._storage.getStorage() || {} as IAccountStorageObject;
        if (currentStorage?.referrer != null && currentStorage.referrer.toLowerCase().indexOf('shoppingcart') !== -1) {
            $('[data-login="guest"]').removeClass('d-none');
            $('[data-altcha-login]').addClass('login-guest');
        }
        const hasValues = $('#guestEmail').val() !== '' && $('#guestConfirmEmail').val() !== '';
        const hasSameValue = $('#guestConfirmEmail').length == 0 || $('#guestEmail').val() === $('#guestConfirmEmail').val();
        const hasGuestFieldErrors = $('#guestEmail').hasClass('field-error') || $('#guestConfirmEmail').hasClass('field-error');

        if (hasValues && hasSameValue && !hasGuestFieldErrors) {
            currentStorage.data.BuyerEmail = $('#guestEmail').val();
            currentStorage.data.CaptchaToken = $('#CaptchaToken').val();
            this._requestHelper.postToUrl(currentStorage.target, currentStorage.data);
        }
    }

    searchSubDivision() {
        const $selected: JQuery<HTMLElement> = this._CountryDropDown.getSelected();

        if ($selected.length === 0) return;

        const isoCode = $selected.attr('data-iso') as string;

        if (isoCode === '') return;

        const countryEntry: CountryList | undefined = this.countryList.find(x => x.isoCode === isoCode);

        if (countryEntry) {
            return this.printSubDivision(countryEntry.subDivisionList);
        }

        AxessViewer.loadPartialView('/AccUtil/GetSubDivisionList', { iso2Code: isoCode }, (res: SubDivisionWithCodeList[]) => {
            this.countryList.push({
                isoCode: isoCode,
                subDivisionList: res,
            });
            this.printSubDivision(res);
        }, {});
    }

    printSubDivision(subDivisionList: SubDivisionWithCodeList[]) {
        const postalCode = this.getPostalCode();
        const $dropDownParent: JQuery<HTMLElement> = $(this._CountryDropDown.getElements()[0]);
        let $stateField = $dropDownParent.next('.state-field');

        if (postalCode && postalCode.length === 0) {
            return this.removePostalCodeInfo($stateField);
        };

        const selectedDivision: SubDivisionWithCodeList | undefined = subDivisionList.find((x: SubDivisionWithCodeList) => x.PostalCodes.includes(postalCode));

        if (!selectedDivision) {
            return this.removePostalCodeInfo($stateField);
        }

        if ($stateField.length > 0) {
            return this.removePostalCodeInfo($stateField);
        }

        if ($stateField.length === 0) {
            const newInfoDiv = document.createElement('div');
            newInfoDiv.classList.add('ax-form-group');
            newInfoDiv.classList.add('ax-mt-1');
            newInfoDiv.classList.add('state-field');

            const newInfoInput = document.createElement('input');
            newInfoInput.setAttribute('type', 'text');
            newInfoInput.setAttribute('disabled', 'disabled');
            newInfoInput.setAttribute('value', selectedDivision.SubDivision.SubDivisionName);
            newInfoInput.classList.add('ax-form-control');


            const newInfoLabel = document.createElement('label');
            newInfoLabel.classList.add('ax-form-label');
            newInfoLabel.innerText = `${this._I18nHelper.GetTranslation(Translations.State)}`;

            const newInfoDivGroupAssistance = document.createElement('div');
            newInfoDivGroupAssistance.classList.add('ax-form-group-assistence');

            newInfoDiv.appendChild(newInfoInput);
            newInfoDiv.appendChild(newInfoLabel);
            newInfoDiv.appendChild(newInfoDivGroupAssistance);

            $dropDownParent.after(newInfoDiv);
            $stateField = $dropDownParent.next('.state-field');
        }
    }

    removePostalCodeInfo($stateField: JQuery<HTMLElement>): void {
        $stateField.remove();
    }

    getPostalCode(): string {
        return $(`${this.parentSelector} .register__postalCode`).val() as string;
    }

    initRentDropdowns(that) {
        this._RentalWeightDropDown.init(`.accountsettings__rentalWeight`, {
            searchBar: false,
            multiSelect: false,
            onSelect: ($parent: JQuery<HTMLElement>, value: string | string[]) => {
                $('#RentalWeight').val(value);
            }
        });

        this._RentalHeightDropDown.init(`.accountsettings__rentalHeight`, {
            searchBar: false,
            multiSelect: false,
            onSelect: ($parent: JQuery<HTMLElement>, value: string | string[]) => {
                $('#RentalHeight').val(value);
            }
        });

        this._RentalShowSizeDropDown.init(`.accountsettings__rentalShoeSize`, {
            searchBar: false,
            multiSelect: false,
            onSelect: ($parent: JQuery<HTMLElement>, value: string | string[]) => {
                $('#RentalShoeSize').val(value);
            }
        });

        this._RentalSkiLevelDropDown.init(`.accountsettings__rentalSkiLevel`, {
            searchBar: false,
            multiSelect: false,
            onSelect: ($parent: JQuery<HTMLElement>, value: string | string[]) => {
                $('#RentalSkiLevel').val(value);
            }
        });
    }
}

interface IRegistrationData extends IAxBirthDateInitData {
    birthdayPattern: string;
    parentId: string;
    rental_parentId: string;
    outputTarget: string;
    setDay: string;
    setMonth: string;
    setYear: string;
    setBirthDate: string;
    formData: any;
    loginUrl: string;
    addressType: AddressType;
    minimumAge: number;
    companyDate: string;
}

class CountryList {
    isoCode!: string;
    subDivisionList!: SubDivisionWithCodeList[];
}

class SubDivisionWithCodeList {
    SubDivision!: CustomerSubDivision;
    PostalCodes!: string[];
}

class CustomerSubDivision {
    SubDivisionCode!: string;
    SubDivisionName!: string;
}

export enum AddressType {
    Default,
    USA,
    Japan
}